
<template>
  <div>

     <md-table>
          <md-table-row>
              <md-table-head>#</md-table-head>
              <md-table-head>Criação</md-table-head>
              <md-table-head>Cliente</md-table-head>
              <md-table-head>Valor</md-table-head>
              <md-table-head>Inicio</md-table-head>
              <md-table-head>Fim</md-table-head>
              <md-table-head></md-table-head>
          </md-table-row>

          <md-table-row v-for="item in items" :key="item.id">
              <md-table-cell>{{ item.id }}</md-table-cell>
              <md-table-cell>{{ item.created_at }}</md-table-cell>
              <md-table-cell>{{ item.customer.name}}</md-table-cell>
              <md-table-cell>{{ item.amount }}</md-table-cell>
              <md-table-cell>{{ item.start_date }}</md-table-cell>
              <md-table-cell>{{ item.end_date }}</md-table-cell>
              <md-table-cell>
                    <md-button @click="cancelRecurrent(item.id)" class="md-raised md-accent">Cancelar</md-button>
              </md-table-cell>
      </md-table-row>
    </md-table>          
  </div>
</template>

<script>
 
export default {
  props:{
      items: Array
  },
  methods:{
    cancelRecurrent(index){

       if(!confirm("Deseja cancelar?")){
         return false
       }

       window.console.log(index)

       // this.$notify({ group:"notify", text: 'Cancelado com sucesso', type:"success",  });
 
    }
  }
};
</script>
